import React, { useState, useEffect } from 'react';
import { Spinner, Alert, Button, Modal, Form, Dropdown } from 'react-bootstrap';
import { Download, XCircle, Clock } from 'react-bootstrap-icons';
import apinode from '../../services/apinode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Boletos.css';
import Navbar from '../../components/navbar/navbar';
import { formatDate } from '../../utils/formatDate';
import { parseISO } from 'date-fns';
import { Print } from '@material-ui/icons';
import ReactPaginate from 'react-paginate';

function Boletos() {
    const [boletos, setBoletos] = useState([]);
    const [filteredBoletos, setFilteredBoletos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedBoleto, setSelectedBoleto] = useState(null);
    const [dataVencimento, setDataVencimento] = useState('');
    const [seuNumero, setSeuNumero] = useState('');
    const [isLoadingB, setIsLoading] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [boletosPerPage, setBoletosPerPage] = useState(5);
    const [filter, setFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); // Adicionei o estado para armazenar o termo de pesquisa

    useEffect(() => {
        const fetchBoletos = async () => {
            try {
                const response = await apinode.get(`sicredi/boletos/${localStorage.idconta}`);
                setBoletos(response.data);
                setFilteredBoletos(response.data);
            } catch (err) {
                setError('Erro ao carregar boletos');
            } finally {
                setLoading(false);
            }
        };

        fetchBoletos();
    }, []);

    const handleImprimirBoleto = async (linhaDigitavel, index) => {
        setIsLoading((prevState) => ({
            ...prevState,
            [index]: true,
        }))

        try {
            // Fazer a requisição GET para obter o PDF
            const response = await apinode.get(
                `/sicredi/imprimir_bol_sicredi/${localStorage.idconta}`,
                {
                    params: { linhaDigitavel }, // Passa o codigoParcela como query string
                    responseType: 'blob', // Configura a resposta para ser um blob (binário)
                },
            )

            // Criar uma URL para o blob recebido
            const file = new Blob([response.data], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(file)

            // Abrir o PDF em uma nova aba
            window.open(fileURL, '_blank')

            console.log('Boleto gerado com sucesso:', response.data)
            toast.success('Boleto gerado com sucesso!')
        } catch (error) {
            console.error('Erro ao gerar o boleto:', error)
            toast.error('Erro ao gerar o boleto:', error.message)
        } finally {
            setIsLoading((prevState) => ({
                ...prevState,
                [index]: false,
            }))
        }
    }

    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        // Filtrar boletos com base nos campos: nome, CPF/CNPJ, valor, etc.
        const boletosFiltrados = boletos.filter(boleto =>
            boleto.pes_razao.toLowerCase().includes(term) ||
            boleto.pes_cnpj_cpf.includes(term) ||
            boleto.valor.toString().includes(term) ||
            boleto.situacao.toLowerCase().includes(term) ||
            boleto.nossonumero.includes(term)
        );

        setFilteredBoletos(boletosFiltrados);
        setCurrentPage(0); // Resetar a página para o início após a pesquisa
    };

    const formatarValor = (valor) => valor.toFixed(2).replace('.', ',');

    const handleDownload = async (id) => {
        const desejaBaixar = window.confirm('Deseja baixar as contas selecionadas?');

        if (desejaBaixar) {
            try {
                const response = await apinode.put(`/contasreceber/pgconta/${localStorage.idconta}?ids=${id}`, {});
                toast.success(`Sucesso: ${response.data.retorno}`, { position: toast.POSITION.TOP_RIGHT });
            } catch (error) {
                toast.error(`Erro ao baixar as contas: ${error.message}`, { position: toast.POSITION.TOP_RIGHT });
            }
        } else {
            toast.info('O download das contas foi cancelado.', { position: toast.POSITION.TOP_RIGHT });
        }
    };

    const handleCancel = async (boletoId) => {
        const confirmed = window.confirm('Tem certeza que deseja cancelar este boleto?');
        const conta = localStorage.idconta;

        if (confirmed) {
            try {
                const response = await apinode.patch(`/sicredi/cancelar_bol_sicredi/${conta}/${boletoId}`);
                toast.success('Boleto cancelado com sucesso');
            } catch (error) {
                toast.error('Falha ao cancelar o boleto.' + error.response.data.error);
            }
        }
    };

    const handleExtend = async () => {
        try {
            const payload = {
                dataVencimento: formatDate(parseISO(dataVencimento), 'yyyy-MM-dd'),
                seuNumero,
            };

            await apinode.patch(`/sicredi/atualizar_bol_sicredi/${localStorage.idconta}/${seuNumero}`, payload);
            const response = await apinode.get(`/sicredi/boletos/${localStorage.idconta}`);
            setBoletos(response.data);
            setFilteredBoletos(response.data);
            setShowModal(false);
            setDataVencimento('');
            setSeuNumero('');
            toast.success('Boleto prorrogado com sucesso!');
        } catch (err) {
            toast.error('Erro ao prorrogar boleto');
        }
    };

    const handleShow = (boleto) => {
        setSelectedBoleto(boleto.id);
        setDataVencimento('');
        setSeuNumero(boleto.nossonumero);
        setShowModal(true);
    };

    const handleFilterChange = (eventKey) => {
        setFilter(eventKey);
        if (eventKey === '') {
            setFilteredBoletos(boletos);
        } else {
            const boletosFiltrados = boletos.filter(boleto => boleto.situacao === eventKey);
            setFilteredBoletos(boletosFiltrados);
            setCurrentPage(0);
        }
    };

    const handlePageChange = (selectedPage) => setCurrentPage(selectedPage.selected);

    const handleItemsPerPageChange = (eventKey) => {
        setBoletosPerPage(Number(eventKey));
        setCurrentPage(0);
    };

    const indexOfLastBoleto = currentPage * boletosPerPage + boletosPerPage;
    const indexOfFirstBoleto = currentPage * boletosPerPage;
    const currentBoletos = filteredBoletos.slice(indexOfFirstBoleto, indexOfLastBoleto);

    if (loading) return <Spinner animation="border" />;
    if (error) return <Alert variant="danger">{error}</Alert>;

    return (
        <>
            <Navbar />
            <div className="container mt-page">
                <h1>Lista de Boletos</h1>

                {/* Campo de Pesquisa */}
                <div className="d-flex justify-content-start mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Pesquisar por nome, CPF, valor, situação, etc."
                        value={searchTerm}
                        onChange={handleSearch}
                        className="mr-2"
                    />

                    <Dropdown onSelect={handleFilterChange} className="mr-2">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Filtrar por Situação
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
                            <Dropdown.Item eventKey="EM CARTEIRA">Em Carteira</Dropdown.Item>
                            <Dropdown.Item eventKey="LIQUIDADO REDE">Pago</Dropdown.Item>
                            <Dropdown.Item eventKey="VENCIDO">Vencido</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown onSelect={handleItemsPerPageChange}>
                        <Dropdown.Toggle variant="secondary" id="dropdown-items-per-page">
                            Itens por Página
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="5">5</Dropdown.Item>
                            <Dropdown.Item eventKey="10">10</Dropdown.Item>
                            <Dropdown.Item eventKey="15">15</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {currentBoletos.map((boleto) => (
                    <div
                        key={boleto.id}
                        className={`boleto-card ${boleto.situacao === 'VENCIDO'
                            ? 'vencido'
                            : boleto.situacao === 'LIQUIDADO REDE' || boleto.situacao === 'LIQUIDADO COMPE'
                                ? 'pago'
                                : ''
                            }`}
                    >

                        <div className="header">
                            <h5>{boleto.pes_razao}</h5>
                            <div className="actions">
                                <Button className="download" onClick={() => handleDownload(boleto.id)} title="Baixar">
                                    <Download />
                                </Button>
                                <Button className="cancel" onClick={() => handleCancel(boleto.nossonumero)} title="Cancelar">
                                    <XCircle />
                                </Button>
                                <Button className="extend" onClick={() => handleShow(boleto)} title="Prorrogar">
                                    <Clock />
                                </Button>
                                <Button className="primary" onClick={() => handleImprimirBoleto(boleto.linhaDigitavel)} title="Imprimir">
                                    <Print />
                                </Button>
                            </div>
                        </div>
                        <div className="details">
                            <div><span>CPF/CNPJ:</span> {boleto?.pes_cnpj_cpf}</div>
                            <div className="value"><span>Valor:</span> R$ {formatarValor(boleto.valor)}</div>
                            <div><span>Situação:</span> {boleto?.situacao}</div>
                            <div><span>Situação Interna:</span> {boleto?.situacaointerna}</div>
                            <div>
                                <span>Data de Vencimento:</span>
                                {boleto?.dataVencimento
                                    ? new Date(boleto.dataVencimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
                                    : 'Data não informada'}
                            </div>
                            <div><span>Nosso Número:</span> {boleto?.nossonumero}</div>
                            <div><span>Linha Digitável:</span> {boleto?.linhaDigitavel}</div>
                        </div>
                    </div>
                ))}

                <ReactPaginate
                    previousLabel={"← Anterior"}
                    nextLabel={"Próximo →"}
                    pageCount={Math.ceil(filteredBoletos.length / boletosPerPage)}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    previousLinkClassName={"pagination__link"}
                    nextLinkClassName={"pagination__link"}
                    disabledClassName={"pagination__link--disabled"}
                    activeClassName={"pagination__link--active"}
                    forcePage={currentPage}
                />
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Prorrogar Boleto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formDataVencimento">
                            <Form.Label>Data de Vencimento</Form.Label>
                            <Form.Control
                                type="date"
                                value={dataVencimento}
                                onChange={(e) => {
                                    const selectedDate = e.target.value;
                                    setDataVencimento(selectedDate);
                                }}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formSeuNumero">
                            <Form.Label>Seu Número</Form.Label>
                            <Form.Control
                                type="text"
                                value={seuNumero}
                                onChange={(e) => setSeuNumero(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={handleExtend}>
                        Prorrogar
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer />
        </>
    );
}

export default Boletos;
